import { defineNuxtPlugin } from '#app'

const TAWK_SCRIPT_URL =
  'https://embed.tawk.to/5891ad1e34fec90a6ab3e0d9/default'

export default defineNuxtPlugin(() => {
  let tawkLoadPromise

  return {
    provide: {
      startTawk: () => {
        if (tawkLoadPromise) return tawkLoadPromise

        window.Tawk_API = window.Tawk_API || {}
        window.Tawk_LoadStart = new Date()

        tawkLoadPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script')
          script.async = true
          script.src = TAWK_SCRIPT_URL
          script.setAttribute('crossorigin', '*')

          script.addEventListener('load', resolve, { once: true })
          script.addEventListener(
            'error',
            () => {
              script.remove()
              tawkLoadPromise = undefined
              reject(new Error('Tawk.to failed to load'))
            },
            { once: true },
          )

          document.head.appendChild(script)
        })

        return tawkLoadPromise
      },
    },
  }
})
